export default __webpack_public_path__ + "static/media/esg-dashboard.01745978.svg";